<div class="d-flex justify-content-between align-items-center">
  <h5 class="mb-3">Earnings</h5>
  <p>
    Payout Frequency: <span class="fw-bold">{{ payoutFrequency }}</span>
  </p>
</div>
<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <div class="d-flex gap-2">
      <!--<div class="border px-3 py-2 rounded">
        <span>Financial Year: </span>
        <span class="fw-medium">{{ financialYear }}</span>
      </div>-->

      <div class="border px-3 py-2 rounded">
        <span>Business Entity: </span>
        <span class="fw-medium">{{ businessEntity$ | async }}</span>
      </div>
    </div>
    <a target="_blank" [href]="imageBaseUrl + 'contractor-payroll-input.csv'">Inputs Template</a>
  </div>
</div>

<!-- Warning -->
<!--<div class="warning-box my-3">
  <strong>Warnings (may affect your payroll run calculations)</strong><br />
  Investments are currently unlocked, all declared investments will be considered for this payroll –
  <a href="#">Click to Lock</a>
</div>-->

<!-- Payroll Controls -->
<div class="mb-3 d-flex justify-content-between align-items-center">
  <div>
    <label for="fileUploadInput" class="btn btn-success">Upload Inputs</label>
    <input
      type="file"
      id="fileUploadInput"
      (change)="onFileSelect($event)"
      accept=".csv"
      style="display: none"
    />
    <button (click)="syncLopDays()" class="btn btn-outline-primary ms-2">Sync LOP days</button>
    <!--<button class="btn btn-outline-primary ms-2">Sync Expenses and Travel Advances</button>-->
  </div>
  <div>
    <button (click)="onSubmit(false)" class="btn btn-light">Save For Later</button>
    <button
      class="btn btn-primary"
      (click)="onSubmit(true)"
      [disabled]="
        payrollBatchForm.invalid ||
        (fixedPayrollsFormArray.length === 0 && hourlyPayrollsFormArray.length === 0)
      "
    >
      Process Inputs And Review
    </button>
  </div>
</div>

<!-- Fixed Basis Payrolls Table -->
<div class="table-responsive" *ngIf="fixedPayrollsFormArray.length > 0">
  <form [formGroup]="payrollBatchForm">
    <div formArrayName="fixedPayrolls">
      <table class="table datatable">
        <thead class="thead-light">
          <tr>
            <th scope="col">Full Name</th>
            <th scope="col">Gross Payout</th>
            <th scope="col">Net Payout</th>
            <th scope="col">TDS Percentage</th>
            <th scope="col">TDS</th>
            <th scope="col">Effective From</th>
            <th scope="col">Key Settings</th>
            <th scope="col">Invoice</th>
            <th scope="col">LOP Days</th>
            <th scope="col">Bonus</th>
            <th scope="col">Expenses</th>
            <th scope="col">Adjustments</th>
            <th scope="col">Rounding</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let payrollCtrl of fixedPayrollsFormArray.controls; let i = index"
            [formGroupName]="i"
            class="employee-row"
          >
            <td>
              <!--{{ currentIncomingPayrolls[i].employee.firstName || 'N/A' }}
              {{ currentIncomingPayrolls[i].employee.lastName }}-->
              <!--({{ getEmployeeSalary(i).employeeId }})-->

              <div class="d-flex align-items-center">
                <a
                  [routerLink]="[
                    eps.hrm.employeePath,
                    currentIncomingPayrolls.fixed[i].employee.id
                  ]"
                  class="avatar avatar-md"
                >
                  <!-- <img
                        [src]="employee.picture ? businessImages[employee.picture] : defaultImg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      /> -->
                  <ng-container
                    *ngIf="currentIncomingPayrolls.fixed[i].employee.picture; else initials"
                  >
                    <img
                      [src]="imageBaseUrl + currentIncomingPayrolls.fixed[i].employee.picture"
                      class="img-fluid rounded-circle"
                      alt="img"
                      style="width: 100%; height: 100%; object-fit: cover"
                    />
                  </ng-container>

                  <ng-template #initials>
                    <span
                      class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                      style="width: 30px; height: 30px"
                      >{{
                        getInitials(
                          currentIncomingPayrolls.fixed[i].employee.firstName,
                          currentIncomingPayrolls.fixed[i].employee.lastName
                        )
                      }}</span
                    >
                  </ng-template>
                </a>
                <div class="ms-2">
                  <p class="text-dark mb-0">
                    <a
                      [routerLink]="[
                        eps.hrm.employeePath,
                        currentIncomingPayrolls.fixed[i].employee.id
                      ]"
                      >{{ currentIncomingPayrolls.fixed[i].employee.firstName | capitalize }}
                      {{ currentIncomingPayrolls.fixed[i].employee.lastName | capitalize }}</a
                    >
                    <span class="fs-12">
                      ({{ currentIncomingPayrolls.fixed[i].employee.empId }})</span
                    >
                  </p>
                  <span class="fs-12">{{
                    currentIncomingPayrolls.fixed[i].employee.designation?.designationName
                      | capitalize
                  }}</span>
                </div>
              </div>
            </td>
            <td>
              {{
                payrollCtrl.get('grossPayout')?.value
                  | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
              }}
            </td>
            <td>
              {{
                payrollCtrl.get('netPayout')?.value | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
              }}
            </td>
            <td>
              <select
                (change)="onTdsPercentChange($event, payrollCtrl)"
                class="form-select"
                id="tdsPercent"
              >
                <option selected disabled value="">Select</option>
                <option *ngFor="let val of tdsPercentValues" [ngValue]="val">{{ val }}%</option>
              </select>
            </td>
            <td>
              <input
                type="number"
                style="min-width: 5rem"
                class="form-control form-control-sm"
                placeholder="TDS"
                formControlName="tds"
                appTrimInput
              />
            </td>
            <td>
              {{
                getUpdatedEffectiveFromDate(
                  currentIncomingPayrolls.fixed[i].payoutAgreement.effectiveFrom ?? '',
                  currentIncomingPayrolls.fixed[i].employee.joiningDate,
                  payPeriodStartDate
                ) | date: 'dd MMM yyyy'
              }}
            </td>
            <td>
              <button
                (click)="openModal(KeySettingsComponent, i, false)"
                class="btn bg-transparent"
              >
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <td>
              <button (click)="openModal(InvoiceComponent, i, false)" class="btn bg-transparent">
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                style="width: 60px"
                placeholder="LOP"
                formControlName="lopDays"
                appTrimInput
                min="0"
                max="31"
                (input)="onLopInput(payrollCtrl)"
              />
              <div
                *ngIf="
                  payrollCtrl.get('lopDays')?.invalid &&
                  (payrollCtrl.get('lopDays')?.touched || payrollCtrl.get('lopDays')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('lopDays')?.errors?.['required']"
                  >LOP is required.</span
                >
                <span *ngIf="payrollCtrl.get('lopDays')?.errors?.['min']"
                  >LOP cannot be negative.</span
                >
                <span *ngIf="payrollCtrl.get('lopDays')?.errors?.['max']"
                  >LOP days exceed max.</span
                >
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="bonus"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('bonus')?.invalid &&
                  (payrollCtrl.get('bonus')?.touched || payrollCtrl.get('bonus')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('bonus')?.errors?.['required']"
                  >Bonus is required.</span
                >
                <span *ngIf="payrollCtrl.get('bonus')?.errors?.['min']"
                  >Bonus cannot be negative.</span
                >
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="expenses"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('expenses')?.invalid &&
                  (payrollCtrl.get('expenses')?.touched || payrollCtrl.get('expenses')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('expenses')?.errors?.['required']"
                  >Expenses are required.</span
                >
                <span *ngIf="payrollCtrl.get('expenses')?.errors?.['min']"
                  >Expenses cannot be negative.</span
                >
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="adjustments"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('adjustments')?.invalid &&
                  (payrollCtrl.get('adjustments')?.touched || payrollCtrl.get('adjustments')?.dirty)
                "
                class="text-danger small"
              >
                Adjustments required.
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="rounding"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('rounding')?.invalid &&
                  (payrollCtrl.get('rounding')?.touched || payrollCtrl.get('rounding')?.dirty)
                "
                class="text-danger small"
              >
                Rounding required.
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>

<!-- Hourly Payrolls Table -->
<div class="table-responsive pt-4" *ngIf="hourlyPayrollsFormArray.length > 0">
  <form [formGroup]="payrollBatchForm">
    <div formArrayName="hourlyPayrolls">
      <table class="table datatable">
        <thead class="thead-light">
          <tr>
            <th scope="col">Full Name</th>
            <th scope="col">Gross Payout</th>
            <th scope="col">Net Payout</th>
            <th scope="col">TDS Percentage</th>
            <th scope="col">TDS</th>
            <th scope="col">Effective From</th>
            <th scope="col">Key Settings</th>
            <th scope="col">Invoice</th>
            <th scope="col">Work Hours</th>
            <th scope="col">Bonus</th>
            <th scope="col">Expenses</th>
            <th scope="col">Adjustments</th>
            <th scope="col">Rounding</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let payrollCtrl of hourlyPayrollsFormArray.controls; let i = index"
            [formGroupName]="i"
            class="employee-row"
          >
            <td>
              <!--{{ currentIncomingPayrolls[i].employee.firstName || 'N/A' }}
              {{ currentIncomingPayrolls[i].employee.lastName }}-->
              <!--({{ getEmployeeSalary(i).employeeId }})-->

              <div class="d-flex align-items-center">
                <a
                  [routerLink]="[
                    eps.hrm.employeePath,
                    currentIncomingPayrolls.hourly[i].employee.id
                  ]"
                  class="avatar avatar-md"
                >
                  <!-- <img
                        [src]="employee.picture ? businessImages[employee.picture] : defaultImg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      /> -->
                  <ng-container
                    *ngIf="currentIncomingPayrolls.hourly[i].employee.picture; else initials"
                  >
                    <img
                      [src]="imageBaseUrl + currentIncomingPayrolls.hourly[i].employee.picture"
                      class="img-fluid rounded-circle"
                      alt="img"
                      style="width: 100%; height: 100%; object-fit: cover"
                    />
                  </ng-container>

                  <ng-template #initials>
                    <span
                      class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                      style="width: 30px; height: 30px"
                      >{{
                        getInitials(
                          currentIncomingPayrolls.hourly[i].employee.firstName,
                          currentIncomingPayrolls.hourly[i].employee.lastName
                        )
                      }}</span
                    >
                  </ng-template>
                </a>
                <div class="ms-2">
                  <p class="text-dark mb-0">
                    <a
                      [routerLink]="[
                        eps.hrm.employeePath,
                        currentIncomingPayrolls.hourly[i].employee.id
                      ]"
                      >{{ currentIncomingPayrolls.hourly[i].employee.firstName | capitalize }}
                      {{ currentIncomingPayrolls.hourly[i].employee.lastName | capitalize }}</a
                    >
                    <span class="fs-12">
                      ({{ currentIncomingPayrolls.hourly[i].employee.empId }})</span
                    >
                  </p>
                  <span class="fs-12">{{
                    currentIncomingPayrolls.hourly[i].employee.designation?.designationName
                      | capitalize
                  }}</span>
                </div>
              </div>
            </td>
            <td>
              {{
                payrollCtrl.get('grossPayout')?.value
                  | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
              }}
            </td>
            <td>
              {{
                payrollCtrl.get('netPayout')?.value | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
              }}
            </td>
            <td>
              <select
                (change)="onTdsPercentChange($event, payrollCtrl)"
                class="form-select"
                id="tdsPercent"
              >
                <option selected disabled value="">Select</option>
                <option *ngFor="let val of tdsPercentValues" [ngValue]="val">{{ val }}%</option>
              </select>
            </td>
            <td>
              <input
                type="number"
                style="min-width: 5rem"
                class="form-control form-control-sm"
                placeholder="TDS"
                formControlName="tds"
                appTrimInput
              />
            </td>
            <td>
              {{
                getUpdatedEffectiveFromDate(
                  currentIncomingPayrolls.hourly[i].payoutAgreement.effectiveFrom ?? '',
                  currentIncomingPayrolls.hourly[i].employee.joiningDate,
                  payPeriodStartDate
                ) | date: 'dd MMM yyyy'
              }}
            </td>
            <td>
              <button (click)="openModal(KeySettingsComponent, i, true)" class="btn bg-transparent">
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <td>
              <button (click)="openModal(InvoiceComponent, i, true)" class="btn bg-transparent">
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                style="width: 60px"
                placeholder="Work Hours"
                formControlName="totalHours"
                appTrimInput
                min="0"
              />
              <div
                *ngIf="
                  payrollCtrl.get('totalHours')?.invalid &&
                  (payrollCtrl.get('totalHours')?.touched || payrollCtrl.get('totalHours')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('totalHours')?.errors?.['required']"
                  >Work Hour is required.</span
                >
                <span *ngIf="payrollCtrl.get('totalHours')?.errors?.['min']"
                  >Work Hour cannot be negative.</span
                >
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="bonus"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('bonus')?.invalid &&
                  (payrollCtrl.get('bonus')?.touched || payrollCtrl.get('bonus')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('bonus')?.errors?.['required']"
                  >Bonus is required.</span
                >
                <span *ngIf="payrollCtrl.get('bonus')?.errors?.['min']"
                  >Bonus cannot be negative.</span
                >
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="expenses"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('expenses')?.invalid &&
                  (payrollCtrl.get('expenses')?.touched || payrollCtrl.get('expenses')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('expenses')?.errors?.['required']"
                  >Expenses are required.</span
                >
                <span *ngIf="payrollCtrl.get('expenses')?.errors?.['min']"
                  >Expenses cannot be negative.</span
                >
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="adjustments"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('adjustments')?.invalid &&
                  (payrollCtrl.get('adjustments')?.touched || payrollCtrl.get('adjustments')?.dirty)
                "
                class="text-danger small"
              >
                Adjustments required.
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="rounding"
                appTrimInput
              />
              <div
                *ngIf="
                  payrollCtrl.get('rounding')?.invalid &&
                  (payrollCtrl.get('rounding')?.touched || payrollCtrl.get('rounding')?.dirty)
                "
                class="text-danger small"
              >
                Rounding required.
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>
